import React from 'react';

// Utils
import { useClass } from '@breezerr';
import { useBreakpoint } from '@brz-utils/contexts/is.breakpoint';

// Components
import { Dialog, SwipeableDrawer, IconButton, PaperProps, DrawerProps, Drawer } from '@mui/material';
import { Close } from '@mui/icons-material';


type Props = {
    open: boolean;
    onClose?: () => void;
    onExited?: () => void;
    PaperProps?: {
        Drawer?: PaperProps,
        Dialog?: PaperProps
    };
    SlotProps?: {
        Dialog?: DrawerProps['slotProps']
    };
    children: React.ReactNode | React.ReactNode[];
    disableDrawer?: boolean;
    disableClosing?: boolean;
};

export const BrzDialog = (props: Props) => {
    const { isMobile } = useBreakpoint();

    const [open, setOpen] = React.useState(props.open);

    React.useEffect(() => {
        setOpen(props.open);
    }, [props.open]);

    React

    // Functions
    const handleClose = () => {
        if ( typeof props.onClose === 'function' ) {
            props.onClose();
        }
    };

    const handleExited = () => {
        if ( typeof props.onExited === 'function' ) {
            props.onExited();
        }
    };

    return !isMobile || props.disableDrawer ? (
        // Desktop
        <Dialog
            open={open}
            onClose={handleClose}
            TransitionProps={{
                onExited: handleExited
            }}
            PaperProps={{
                className: useClass('p-relative'),
                elevation: 4,
                ...props.PaperProps?.Dialog,
            }}
            disableEscapeKeyDown={props.disableClosing}
            slotProps={props.SlotProps?.Dialog}
            
        >
            {typeof props.onClose === 'function' && !props.disableClosing ? (
                <IconButton 
                    onClick={() => setOpen(false)} 
                    className={useClass('p-absolute right-1rem top-1rem bg-color-white!')} 
                    size="medium"
                >
                    <Close fontSize="large" color="primary" />
                </IconButton>
            ) : null}

            {props.children}
        </Dialog>
    ) : (
        // Mobile
        !props.disableClosing ? (
            <SwipeableDrawer
                open={props.open}
                onClose={handleClose}
                onOpen={() => {}}
                PaperProps={{
                    ...props.PaperProps?.Drawer
                }}
                anchor='bottom'
                disableSwipeToOpen
                disableDiscovery
            >
                <div className={useClass('p-absolute left-0x top-1.5rem w-100% d-flex justify-content-center')}>
                    <svg className={useClass('')} xmlns="http://www.w3.org/2000/svg" width="42.507" height="8.851" viewBox="0 0 42.507 8.851">
                        <g transform="translate(-161.095 -337.117)">
                            <line x2="20" transform="matrix(0.966, 0.259, -0.259, 0.966, 162.932, 338.954)" fill="none" stroke="#e1e4ed" strokeLinecap="round" strokeWidth="3"/>
                            <line x2="20" transform="matrix(0.966, -0.259, 0.259, 0.966, 182.446, 344.13)" fill="none" stroke="#e1e4ed" strokeLinecap="round" strokeWidth="3"/>
                        </g>
                    </svg>
                </div>

                {props.children}
            </SwipeableDrawer>
        ) : (
            <Drawer
                open={props.open}
                onClose={handleClose}
                PaperProps={{
                    ...props.PaperProps?.Drawer
                }}
                anchor='bottom'
            >
                {!props.disableClosing ? (
                    <div className={useClass('p-absolute left-0x top-1.5rem w-100% d-flex justify-content-center')}>
                        <svg className={useClass('')} xmlns="http://www.w3.org/2000/svg" width="42.507" height="8.851" viewBox="0 0 42.507 8.851">
                            <g transform="translate(-161.095 -337.117)">
                                <line x2="20" transform="matrix(0.966, 0.259, -0.259, 0.966, 162.932, 338.954)" fill="none" stroke="#e1e4ed" strokeLinecap="round" strokeWidth="3"/>
                                <line x2="20" transform="matrix(0.966, -0.259, 0.259, 0.966, 182.446, 344.13)" fill="none" stroke="#e1e4ed" strokeLinecap="round" strokeWidth="3"/>
                            </g>
                        </svg>
                    </div>
                ) : null}

                {props.children}
            </Drawer>
        )
    )
};